import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-transaction-delete-modal',
  templateUrl: './transaction-delete-modal.component.html',
  styleUrls: ['./transaction-delete-modal.component.scss'],
})
export class TransactionDeleteModalComponent {
  public action: string;
  public local_data: any;
  public msg: string;

  constructor(
    public dialogRef: MatDialogRef<TransactionDeleteModalComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.msg = data.msg;
    this.action = data.action;
    delete data.msg;
    delete data.action;
    this.local_data = Object.assign({}, data);
  }

  doAction() {
    this.dialogRef.close({ event: this.action, data: this.data });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
